import _ from 'lodash';
import qs from 'query-string';
import {
  comparablesMappingHandler,
  productListMappingHandler,
  productKeyMappingHandler,
  filterDataMappingHandler,
  mortgageFilterDataMappingHandler,
  contentGroupingsTrack,
} from 'components/tracking/TrackingUtils';

// TO DO: remove abTestVal after A/B test RA-3310
export function onApplyTrack (props, state, e, data, abTestVal) {
  const { track, list, sortBy } = props;
  const {
    intent, products, productId,
  } = data;
  const { intent: eventIntent } = e;

  if (!_.isEmpty(products)) {
    const productInfo = _.head(_.filter(products, ['id', productId]));
    const productIndex = _.findIndex(products, { id: productId });
    const { filterValues, sortByValue } = state;

    const purchaseIntent = eventIntent || intent || 'apply';
    const { mortgageType } = filterValues;

    const {
      productName,
      promotional,
      __typename,
      comparables,
      provider: productProvider,
      title,
    } = productInfo;

    let type;
    if (promotional) {
      const { type: promotionalType } = promotional;
      type = promotionalType;
    } else {
      type = [];
    }

    const productDetails = (comparables) ? comparables.map(comparablesMappingHandler).join('|') : '';
    const { displayValue, prefix, __typename: comparablesTypeName } = _.last(comparables) || {};

    let currency = '';
    let price = '';
    if (comparablesTypeName === 'CompareElementPrice') {
      currency = prefix;
      price = displayValue;
    }

    const productsInfo = [{
      name: productName,
      id: title || '',
      price: price || '',
      currency: currency || '',
      brand: (productProvider) ? productProvider.providerName : '',
      category: __typename,
      purchaseIntent,
      promotion: (type) ? type.map(t => t.key).join('|') : '',
      promoLabel: (type) ? type.map(t => t.display).join('|') : '',
      dealStatus: 'true',
      productDetails,
      position: productIndex + 1,
    }];

    const filterSortby = sortByValue
      || (_.isEmpty(sortBy) ? '' : _.last(sortBy).name);
    const filter = (mortgageType) ? mortgageFilterDataMappingHandler(filterValues)
      : filterDataMappingHandler(filterValues, filterSortby);
    const event = abTestVal ? 'learn more' : 'productClick';
    const actionField = { list };
    const click = Object.assign({}, (mortgageType) ? { mortgage: filter } : { filter },
      { products: productsInfo }, list && { actionField });
    const ecommerce = Object.assign({}, { click });
    const trackingData = Object.assign({}, { ecommerce }, { event });

    track({ data: trackingData });
  }
}

export function onResultListUpdateTrack (props, state) {
  const {
    track,
  } = props;

  const {
    filterValues,
    sortByValue,
    isVirtalPageLoad,
    displayList,
    products,
    sortBy,
    numberInitialResults,
  } = state;

  if (!_.isEmpty(products)) {
    const { mortgageType } = filterValues;
    const filterSortby = sortByValue || _.last(sortBy).name;

    const productsInfo = (products.length <= numberInitialResults)
      ? _.take(products, products.length) : _.take(products, numberInitialResults);

    const impressions = productsInfo && productListMappingHandler(
      productsInfo.map(productKeyMappingHandler), displayList
    );

    let isPageLoad = false;

    /* For handle the page load tracking the reusult page with funnel */
    if (isVirtalPageLoad) {
      isPageLoad = true;
    } else {
      isPageLoad = false;
    }

    const filter = (mortgageType) ? mortgageFilterDataMappingHandler(filterValues)
      : filterDataMappingHandler(filterValues, filterSortby);
    const event = (isPageLoad) ? 'newImpressions' : 'filterAction';
    const click = Object.assign({}, (mortgageType) ? { mortgage: filter } : { filter });
    const ecommerce = Object.assign({}, { impressions }, !isPageLoad && { click });
    const trackingData = Object.assign({}, { ecommerce }, { event });

    track({ data: trackingData });
    return trackingData;
  }

  return false;
}

export function onSortByChangeTrack(props, state, sortBy) {
  const { track } = props;
  const { sortByValue } = state;
  if (sortByValue !== sortBy.name) {
    track({ data: { sorting: sortBy.name } });
  }
}

export function onShowMoreTrack(props, state) {
  const {
    track,
    products,
    numberInitialResults,
    list,
    sortBy,
  } = props;
  const showMoreProducts = products.slice(numberInitialResults);

  const { filterValues, sortByValue } = state;
  if (!_.isEmpty(showMoreProducts)) {
    const productsInfo = showMoreProducts;
    const impressions = productListMappingHandler(
      productsInfo.map(productKeyMappingHandler), list
    );
    const filterSortby = sortByValue
      || (_.isEmpty(sortBy) ? '' : _.last(sortBy).name);

    const filter = filterDataMappingHandler(filterValues, filterSortby);
    const event = 'filterAction';
    const click = Object.assign({}, { filter: [filter] });
    const ecommerce = Object.assign({}, { impressions }, { click });
    const trackingData = Object.assign({}, { ecommerce }, { event });

    track({ data: trackingData });
  }
}

export function onResultPageLoadTrack(props, state) {
  const {
    track,
    products,
    numberInitialResults,
    list: currentList,
    defaultList,
    location,
  } = props;
  const { from } = qs.parse(location.search);
  const list = currentList || defaultList;
  const {
    sortByValue,
  } = state;
  if (!_.isEmpty(products)) {
    const productsInfo = (products.length >= numberInitialResults)
      ? _.take(products, numberInitialResults) : _.take(products, products.length);
    if (sortByValue === null) {
      const impressionsData = productListMappingHandler(
        productsInfo.map(productKeyMappingHandler), list
      );
      const trackingData = {};
      if (from === 'ccpr') {
        trackingData.event = 'productCompare';
      }
      const locationObjKey = location ? Object.keys(location) : [];
      if (!locationObjKey.includes('state')) {
        trackingData.event = 'newImpressions';
      }

      trackingData.ecommerce = {
        impressions: impressionsData,
      };
      track({ data: trackingData });
    }
  }
}

export function onFiltersChangeTrack(props, filter) {
  const { track } = props;
  const { queryParam, value } = filter;
  if (_.isArray(value)) {
    let queryType;
    switch (queryParam) {
      case 'needs': queryType = 'filterNeed'; break;
      case 'providers': queryType = 'filterProvider'; break;
      case 'platformFeatures': queryType = 'filterPlatformFeatures'; break;
      case 'investmentTypes': queryType = 'filterInvestmentTypes'; break;
      case 'privileges': queryType = 'filterPrivileges'; break;
      case 'promotions': queryType = 'filterPromotions'; break;
      default:
    }
    const trackData = {};
    trackData[queryType] = value.join(',');
    track({ data: trackData });
    track({ data: { filterType: queryParam } });
    return trackData;
  }
  if (queryParam !== 'list') {
    let queryType;
    switch (queryParam) {
      case 'loanAmount': queryType = 'filterAmount'; break;
      case 'loanTenure': queryType = 'filterPeriod'; break;
      case 'repaymentPeriodY': queryType = 'filterPeriod'; break;
      case 'repaymentPeriodM': queryType = 'filterPeriod'; break;
      case 'minMonthlySalary': queryType = 'filterMonthlySalary'; break;
      case 'minAnnualSalary': queryType = 'filterAnnualSalary'; break;
      case 'grossArea': queryType = 'filterFlatSize'; break;
      case 'providers': queryType = 'filterProvider'; break;
      default:
    }
    const trackData = {};
    trackData[queryType] = value;
    track({ data: trackData });
    track({ data: { filterType: queryParam } });
    return trackData;
  }
  return null;
}

export function locationChangeTrack(props, state) {
  const { defaultList, track } = props;

  const {
    funnelQuery: currentFunnelQuery,
    isEditingFunnel: currentIsEditingFunnel,
  } = state;

  let location = '';
  if (defaultList === 'funnel') {
    if (currentIsEditingFunnel) {
      location = 'search';
    } else if (!currentFunnelQuery) {
      location = 'search';
    } else {
      location = 'result';
    }
  } else {
    location = 'result';
  }
  contentGroupingsTrack(track, location);
}

export function verticalTrack(props) {
  const { track, enum: verticalCode } = props;
  track({ data: { verticalCode } });
}

export function mobileFilterButtonClickTrack(props, isMobileFilterPanelShow) {
  const { track } = props;
  track({ data: { event: isMobileFilterPanelShow ? 'filterOpened' : 'filterClosed' } });
}

// Tracking for additional filter inputs for RA-3363
export function mobileFilterInputOutsidePanelChangeTrack(props, filterType, value) {
  const { track } = props;
  track({
    data: {
      event: 'filterModified',
      filterType,
      filterValue: value.value ? value.value : value,
    },
  });
}

// TO DO: Remove Experiment RA-3309
export function mobileExpBankChange(props, value) {
  const { track } = props;
  const trackData = {
    event: 'cro.bank.dropdownlist',
    value,
  };

  track({ data: trackData });
}

export function trackPromotionalBannerClick(track, params = {}) {
  if (!track) {
    return;
  }
  const trackingData = {
    event: 'navigate',
    location: 'result page',
    componentType: 'top-banner',
    action: 'click',
    ...params,
  };
  track({
    data: trackingData,
  });
}
